export default {
    xboot: 'XBoot is a very good web front-end separation architecture development platform',
    usernameLogin: 'UsernameLogin',
    mobileLogin: 'MobileLogin',
    autoLogin: 'Auto Login',
    forgetPass: 'Forget Password',
    otherLogin: 'Sign in with',
    regist: 'Register',
    login: 'Login',
    logining: 'Logining...',
    home: 'home',
    switchLangTitle: 'Switch Lang',
    international: 'Switch Lang',
    userCenter: 'Account Center',
    changePass: 'Account Pass',
    logout: 'Logout',
    tagOption: 'Label Options',
    closeAll: 'Close All',
    closeOthers: 'Close Others',
    help: 'Help',
    privacy: 'Privacy',
    terms: 'Terms',
    rights: 'All Rights Reserved'
};
